module.exports = __webpack_public_path__ + "media/assets/images/sunny_later_will_rain-38b770f773e67df24ed81adb383868b8.png";